import HashRate from "./HashRate";
export default HashRate;
